import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';

import {BaseHttpService} from '../base.service';
import {SessionService} from '../session.service';

import {CvParsedModel} from '../../../cvs/cv.parsed.model';
import 'rxjs/add/observable/of';

@Injectable()
export class UserService extends BaseHttpService {

  private static personalDataPath = 'api/ecv/experts/personal_data/';
  private static updatePersonalDataPath = UserService.personalDataPath + 'update';
  private static cvsPath = 'api/ecv/cvs/';
  private static allCvsPath = UserService.cvsPath + 'all/';
  private static uploadCvPath = UserService.cvsPath + 'create';
  private static parseCvPath = UserService.cvsPath + 'parsed_cv/';
  private static saveParsedCvPath = UserService.parseCvPath + 'save';
  private static expertExistsPath = 'api/ecv/experts/';
  private static addressesPath = 'api/ecv/experts/addresses/';
  private static allAddressesPath = UserService.addressesPath + 'all/';
  private static updateAddressPath = UserService.addressesPath + 'update';
  private static createAddressPath = UserService.addressesPath + 'create';
  private static userIdentityPath = 'api/users/user_identity/';
  private static cvContentPath = (cvId: number) => UserService.cvsPath + `${cvId}/content`;
  private static cvOriginalFilePath = (cvId: number) => UserService.cvsPath + `${cvId}/original`;

  constructor(sessionService: SessionService, httpClient: HttpClient) {
    super(httpClient, sessionService);
  }

  checkIfExpertExists(refNumber): Observable<any> {
    return this.httpGet(UserService.expertExistsPath + refNumber);
  }

  getExpertPersonalData(userId: number): Observable<any> {
    return this.httpGet(UserService.personalDataPath + userId);
  }

  getUserIdentity(userId: number): Observable<any> {
    return this.httpGet(UserService.userIdentityPath + userId);
  }

  updateExpertPersonalData(model: any): Observable<any> {
    return this.httpPut(UserService.updatePersonalDataPath, model).map(
      response => {
        Object.assign(model, response);
      })
      .catch((err) => Observable.of(true));
  }

  getExpertAddress(userId: number): Observable<any> {
    return this.httpGet(UserService.allAddressesPath + userId);
  }

  updateExpertAddress(model: any): Observable<any> {
    return this.httpPut(UserService.updateAddressPath, model).map(
      response => {
        Object.assign(model, response);
      })
      .catch((err) => Observable.of(true));
  }

  createExpertAddress(model: any): Observable<any> {
    return this.httpPost(UserService.createAddressPath, model).map(
      response => {
        Object.assign(model, response);
      })
      .catch((err) => Observable.of(true));
  }

  getCvs(userId: number): Observable<any> {
    return this.httpGet(UserService.allCvsPath + userId);
  }

  uploadCv(model: any): Observable<any> {
    return this.httpPost(UserService.uploadCvPath, model);
  }

  parseCv(cvId: number) {
    return this.httpGet(UserService.parseCvPath + cvId);
  }

  saveParsedCv(model: CvParsedModel) {
    return this.httpPost(UserService.saveParsedCvPath, model);
  }

  getCvContent(cvId: number) {
    return this.httpGet(UserService.cvContentPath(cvId), 'text');
  }

  getCvOriginalFile(cvId: number): Observable<any> {
    return this.httpGet(UserService.cvOriginalFilePath(cvId));
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/core/ecv-http-services/services/user.service.ts